// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__rPZH1","fade-in":"styles_fade-in__rmSBi"};